import { Injectable } from '@angular/core';
import { EventMessage, EventType, RedirectRequest } from '@azure/msal-browser';
import { MsalService } from '@azure/msal-angular';

import { AuthDenialCode, AuthErrorConstants, AuthEventContextHelper, securityLog } from '../helpers';
import { AuthAccountService, AuthRequestBuilderService, B2cAuthorityService } from '../services';

@Injectable({
    providedIn: 'root'
})
export class HandleAuthFailureCommand {
    constructor(
        private msalService: MsalService,
        private accountService: AuthAccountService,
        private authRequestBuilder: AuthRequestBuilderService,
        private authorityService: B2cAuthorityService,
        private authEventContext: AuthEventContextHelper,
    ) { }

    public execute(message: EventMessage): boolean {
        securityLog.debug('HandleAuthFailureCommand: execute', { eventType: message.eventType });

        if (message.error && message.error.message.indexOf(AuthErrorConstants.passwordResetCode) > -1) {
            const resetPasswordFlowRequest: RedirectRequest = this.authRequestBuilder.createRedirectRequest(
                [],
                this.authorityService.resetPasswordAuthority
            );
            this.msalService.loginRedirect(resetPasswordFlowRequest);
            return true;
        }

        if (message.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
            return true;
        }

        const denialCode = this.authEventContext.resolveAuthDenialCode(message.error);
        return denialCode === AuthDenialCode.TenantSelectionFailed && this.accountService.hasActiveTenantClaim();
    }
}